<isp-chat-bubble
  *ngFor="let message of messages"
  [data]="message"
  class="chat-bubble"
>
</isp-chat-bubble>
